import { getLengthValue } from '../../../system';
export const withPaddings = ({ theme, ...props }) => {
    const rules = {};
    if (props.padding !== undefined) {
        rules.padding = getLengthValue({ length: props.padding, theme });
    }
    if (props.paddingX !== undefined) {
        rules.paddingLeft = getLengthValue({ length: props.paddingX, theme });
        rules.paddingRight = getLengthValue({ length: props.paddingX, theme });
    }
    if (props.paddingY !== undefined) {
        rules.paddingTop = getLengthValue({ length: props.paddingY, theme });
        rules.paddingBottom = getLengthValue({ length: props.paddingY, theme });
    }
    if (props.paddingLeft !== undefined) {
        rules.paddingLeft = getLengthValue({ length: props.paddingLeft, theme });
    }
    if (props.paddingRight !== undefined) {
        rules.paddingRight = getLengthValue({ length: props.paddingRight, theme });
    }
    if (props.paddingTop !== undefined) {
        rules.paddingTop = getLengthValue({ length: props.paddingTop, theme });
    }
    if (props.paddingBottom !== undefined) {
        rules.paddingBottom = getLengthValue({ length: props.paddingBottom, theme });
    }
    return rules;
};
